import { jsx as _jsx } from "react/jsx-runtime";
import LessonOverviewModalContainer from '../../../containers/LessonsPage/LessonOverviewModalContainer';
import TrackOverviewModalContainer from '../../../containers/TracksPage/TrackOverviewModalContainer';
import { NextPlaylistContent } from './NextPlaylistContent';
export const NextPlaylistContentOverview = ({
  trackId,
  lessonId
}) => {
  return /*#__PURE__*/_jsx(NextPlaylistContent, {
    lessonId: lessonId,
    render: ({
      trackId: nextTrackId,
      lessonId: nextLessonId,
      language
    }) => {
      if (nextTrackId) {
        return /*#__PURE__*/_jsx(TrackOverviewModalContainer, {
          allowFullWidthChildren: true,
          language: language,
          trackId: nextTrackId
        });
      } else if (nextLessonId) {
        return /*#__PURE__*/_jsx(LessonOverviewModalContainer, {
          allowFullWidthChildren: true,
          language: language,
          lessonId: nextLessonId
        });
      }

      return null;
    },
    trackId: trackId
  });
};